/*
form is where we have all the details for all the inputs
for the entity  forms
each entity has their own form
*/
export const form   =  [
	// {	
	// 	name: "code", 
	// 	value:'', 		
	// 	id:'sentpayment_form_code',
	// 	html:'',
	// 	type:'textfield',
	// 	required: false, 
	// }, 
	{	
		name: "provider_id", 
		value:[], 	//just the id	
		valueFull:'',
		id:'sentpayment_form_provider_id',
		html:'',
		type:'autocomplete',
		required: true,  
	},
	{	
		name: "date", 
		value:'0000-00-00',
		date: true, 		
		id:'sentpayment_form_date',
		html:'',
		type:'textfield',
		required: true,  
	},
	{	
		name: "accounts_id", 
		value:[], 	//just the id	
		valueFull:'',
		id:'sentpayment_form_accounts_id',
		html:'',
		type:'autocomplete',
		required: true,  
	},
	{	
		name: "amount", 
		value:'', 		
		id:'sentpayment_form_amount',
		html:'',
		type:'textfield',
		required: true, 
	},
	{
		name: "payment_method",
		value:'',
		id:'sentpayment_form_payment_method',
		html:'',
		type:'multiselect',
		options:['Bank Transfer', 'ACH', 'Wire', 'Check', 'Cash', 'Zelle', 'Other'],
		required: false,
	},
	{	
		name: "reference_number", 
		value:'', 		
		id:'sentpayment_form_reference',
		html:'',
		type:'textfield',
		required: false, 
	},
	{
		name: "check_generation_active",
		value:'',
		id:'sentpayment_form_check_generation_active',
		html:'',
		type:'checkbox',
		required: false,
	},
	{
		name: "check_date",
		value:'0000-00-00',
		date: true,
		id:'sentpayment_form_check_date',
		html:'',
		type:'textfield',
		required: false,
	},
	{
		name: "check_status",
		value:'',
		id:'sentpayment_form_check_status',
		html:'',
		type:'multiselect',
		options:["Generated", "Printed", "Clear"],
		required: false,
	},
	{
		name: "check_amount",
		value:'',
		id:'sentpayment_form_check_amount',
		html:'',
		type:'textfield',
		required: false,
	},
	{
		name: "check_memo",
		value:'',
		id:'sentpayment_form_check_memo',
		html:'',
		type:'textfield',
		required: false,
	},
	{	
		name: "notes", 
		value:'', 		
		id:'sentpayment_form_notes',
		html:'',
		type:'textfield',
		required: false, 
	},
]

//we use this for check changes on form	
export const formCopy = JSON.parse(JSON.stringify(form))
